import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Form, Row, SubmitButton, Textarea, useForm } from '../../../Form2';

export function UserMembershipCreateForm({ form, onSuccess }: { form: any; onSuccess: () => void }) {
  const { t } = useSonTranslation('UserMemberships');

  const { formProps, fetchState, params } = useForm({ form, onSuccess });

  return (
    <Form id="user-membership-details-form" {...formProps}>
      <Row>
        <Textarea label={t('edit.textareaDescription')} param={params.getByName('note')} />
      </Row>
      <SubmitButton
        buttonLabel={t('edit.save')}
        messageSuccess={t('Form:status.success')}
        messageSending={t('Form:status.sending')}
        messageFail={t('Form:status.fail')}
        fetchState={fetchState}
        active={fetchState.type !== 'loading' && fetchState.type !== 'success'}
      />
    </Form>
  );
}
